import { useAssetManagerState } from "../AssetManagerContext/AssetManagerProvider";
import AssetThumbnail from "../AssetUploader/AssetThumbnail";
import styles from "./assetPreviewer.module.css";

interface AssetPreviewerProps {
  previewUrl?: string;
  readonly?: boolean;
  newVersionNotes?: string;
  setNewVersionNotes?: (newVersionNotes: string) => void;
  thumbnail?: boolean;
}

export default function AssetPreviewer({
  readonly,
  previewUrl,
  newVersionNotes,
  setNewVersionNotes,
  thumbnail,
}: Readonly<AssetPreviewerProps>) {
  const { currentSelectedAsset } = useAssetManagerState();

  const currentVersionNumber = currentSelectedAsset.displayVersion || "1";
  const nextVersionNumber = Number(currentVersionNumber) + 1;
  const columnStyleClass = thumbnail ? styles.multiCol : styles.singleCol;

  if (readonly) {
    return (
      <div className={`${styles.assetPreviewer} ${columnStyleClass}`} aria-label="Readonly Asset Previewer">
        {thumbnail && <AssetThumbnail />}
        <div className="asset-details-text">
          <div className="asset-update-row">
            <div className="asset-update-column">
              <label htmlFor="assetName" className="asset-update-label">
                Name:
              </label>
              <input id="assetName" disabled type="text" value={currentSelectedAsset.name} />
            </div>
            <div className="asset-update-column">
              <label htmlFor="fileName" className="asset-update-label">
                File Name:
              </label>
              <input id="fileName" disabled type="text" value={currentSelectedAsset.blobPath.split("/").pop() || ""} />
            </div>
            <div className="asset-update-column">
              <label htmlFor="version" className="asset-update-label">
                Version:
              </label>
              <input id="version" disabled type="text" value={currentVersionNumber} />
            </div>
          </div>
          <div className="asset-update-row">
            <div className="asset-update-column">
              <label htmlFor="description" className="asset-update-label">
                Description:
              </label>
              <input id="description" disabled type="text" value={currentSelectedAsset.description || ""} />
            </div>
            <div className="asset-update-column">
              <label htmlFor="versionNotes" className="asset-update-label">
                Version Notes:
              </label>
              <input
                id="versionNotes"
                disabled
                type="text"
                value={currentSelectedAsset.versionNotes || ""}
                style={!currentSelectedAsset.versionNotes ? { fontStyle: "italic" } : {}}
                placeholder={!currentSelectedAsset.versionNotes ? "No version description yet" : ""}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.assetPreviewer} ${columnStyleClass}`} aria-label="Asset Previewer">
      {thumbnail && <AssetThumbnail url={previewUrl} />}
      <div aria-label="Version information">
        <div>
          <label htmlFor="version-name">Version:</label>
          <input type="text" id="version-name" value={nextVersionNumber} disabled />
        </div>
        <div>
          <label htmlFor="version-notes">New Version Notes:</label>
          <input
            type="text"
            id="version-notes"
            value={newVersionNotes}
            onChange={(e) => {
              setNewVersionNotes?.(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
